import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button'; 

@Component({
  selector: 'app-decline-request-popup',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
     InputTextModule,
    
  ],
  templateUrl: './decline-request-popup.component.html',
  styleUrls: ['./decline-request-popup.component.scss'] // Use styleUrls for an array
})
export class DeclineRequestPopupComponent {
  @Input() visible: boolean = false; // Controls visibility of the dialog
  @Output() visibleChange = new EventEmitter<boolean>(); // Emits when visibility changes (for two-way binding)
  @Output() declineConfirmed = new EventEmitter<string>(); // Emits the remark when decline is confirmed

  remark: string = ''; // Holds the remark entered by the user

  constructor() {}

  onHide(): void {
    this.visibleChange.emit(false); // Update parent component's visible state
    this.remark = ''; // Clear remark when dialog is closed
  }

  onSave(): void {
    if (this.remark.trim()) { // Ensure remark is not empty
      this.declineConfirmed.emit(this.remark.trim());
      this.onHide(); // Close the dialog after emitting
    } else {
      // Optionally, show a validation message to the user
      console.warn('Remark cannot be empty.');
      // You might want to use a PrimeNG MessageService here for user feedback
    }
  }
}